import {observer} from "mobx-react";
import {FormControl} from "../../../../../common/components/libs";
import React from "react";
import {useTranslation} from "react-i18next";
import style from "./../style.module.css";
import {InputLabel, OutlinedInput, Select, MenuItem} from "@material-ui/core";
import { changeEventHandlerDecorator} from "../../../../../common/libs";
import {CookingTime} from "../../../../../services/menu/models";

interface CookingTimeSelectProps {
    item: CookingTime,
    updateValue: (t: CookingTime) => void;
}

const CookingTimeSelect = (props: CookingTimeSelectProps) => {
    const {item, updateValue} = props;
    const {t} = useTranslation(["general", "menu"]);

    const timePeriod: string[] = ["1-5", "5-10", "10-20", "20-30", "30-40", "40-50", "50-60", "60-80"]

    return (
        <FormControl fullWidth variant="outlined" className={style.select}>
            <InputLabel htmlFor="cookingTime">
                {t("menu:menuEditor.inMinutes")}
            </InputLabel>
            <Select
                value={`${item?.fromTime}-${item?.toTime}`}
                onChange={changeEventHandlerDecorator(function (cookingTime: string): void {
                    updateValue({
                                fromTime: parseInt(cookingTime.split("-")[0]),
                                toTime: parseInt(cookingTime.split("-")[1]),
                            });
                })
                }
                input={<OutlinedInput
                    labelWidth={80}
                />}
            >
                {
                    timePeriod.map(time => {
                        return (
                            <MenuItem value={time} key={time}>
                                {time}
                            </MenuItem>
                        )
                    })
                }

            </Select>
        </FormControl>
    )

}

export default observer(CookingTimeSelect);
